import React, {Component} from "react";
import {
  Table,
  Button,
  Row,
  Col
}                         from "react-bootstrap";
import moment             from "moment";

import { IS_VALID }       from "utils";

export default class View extends Component {
  constructor (props) {
    super(props);

    this.timer;

    this.state = {
      timeLeft: 0,
      isStarted: false
    };

    this.startTimer = this.startTimer.bind(this);
  }

  startTimer (isCancel = false) {
    let {
      ScheduledNotification,
      sendNotification
    } = this.props;

    let {
      selectedData
    } = ScheduledNotification;

    let countDown = 10;

    if (isCancel) {
      clearInterval(this.timer);

      this.setState({
        timeLeft: 0,
        isStarted: false
      });
    } else {
      this.setState({
        isStarted: true,
        timeLeft: countDown
      });

      this.timer = setInterval(() => {
        let {
          timeLeft
        } = this.state;

        timeLeft--;

        this.setState({ timeLeft: timeLeft });

        if (timeLeft <= 0) {
          clearInterval(this.timer);

          let isPushDateTimeValid = false;

          if (
            IS_VALID(selectedData) &&
            IS_VALID(selectedData.get("pushDateTime")) &&
            IS_VALID(selectedData.get("sendType")) &&
            selectedData.get("sendType") === "SCHEDULED" &&
            !moment(selectedData.get("pushDateTime")).isBefore(moment())
          ) {
            isPushDateTimeValid = true;
          } else if (
            IS_VALID(selectedData) &&
            IS_VALID(selectedData.get("sendType")) &&
            selectedData.get("sendType") === "IMMEDIATE"
          ) {
            isPushDateTimeValid = true;
          }

          if (!isPushDateTimeValid) {
            this.setState({
              isStarted: false
            });
          } else {
            sendNotification(
              () => {
                this.setState({
                  isStarted: false
                });
              }
            )
          }
        }
      }, 1000);
    }
  }

  render () {
    let {
      isStarted,
      timeLeft
    } = this.state;

    let {
      ScheduledNotification,
      accessible,
      actions
    } = this.props;

    let {
      selectedData,
      isLoadingAction
    } = ScheduledNotification;

    let GET_DATA = (key) => {
      let value = "";

       if (IS_VALID(selectedData) && IS_VALID(selectedData.get(key))) {
        if (key === "specificUsers" || key === "blacklistedUsers") {
          value = selectedData.get(key).join(", ");
        } else if (
          key === "pushDateTime" ||
          key === "dateApproved" ||
          key === "sendingStartDate" ||
          key === "sendingEndDate"
        ) {
          value = moment(selectedData.get("pushDateTime")).format("MMM DD, YYYY hh:mm A");
        } else if (key === "User" || key === "Sender") {
          value = IS_VALID(selectedData.get(key).get("name")) ? selectedData.get(key).get("name") : selectedData.get(key).get("username");
        } else if (key === "cardTypes") {
          value = selectedData.get(key).join(", ");
        } else {
          value = selectedData.get(key);
        }
      }

      return value;
    };

    let status = GET_DATA("status");

    let data = [
      {
        label: "Send Mode",
        value: GET_DATA("sendMode")
      },
      {
        label: "User Type",
        value: GET_DATA("userType")
      },
      {
        label: "Card Holder Type",
        value: GET_DATA("cardTypes")
      },
      {
        label: "Device Type",
        value: GET_DATA("device")
      },
      {
        label: "Screen",
        value: GET_DATA("screen")
      },
      {
        label: "Browser",
        value: GET_DATA("browser")
      },
      {
        label: "Specific Users",
        value: GET_DATA("specificUsers")
      },
      {
        label: "Excluded Users",
        value: GET_DATA("blacklistedUsers")
      }
    ];

    let data2 = [
      {
        label: "Subject",
        value: <p>{GET_DATA("subject")}</p>
      },
      {
        label: "URL",
        value: GET_DATA("url")
      },
      {
        label: "Message",
        value: <p>{GET_DATA("message")}</p>
      },
      {
        label: "Send Type",
        value: GET_DATA("sendType")
      },
      {
        label: "Schedule",
        value: GET_DATA("pushDateTime")
      },
      {
        label: "User",
        value: GET_DATA("User")
      }
    ];

    let data3 = [
      {
        label: "Status",
        value: GET_DATA("status")
      },
      {
        label: "Sender",
        value: GET_DATA("Sender")
      },
      {
        label: "Date Approved",
        value: GET_DATA("dateApproved")
      },
    ];

    let isPushDateTimeValid = false;

    if (
      IS_VALID(selectedData) &&
      IS_VALID(selectedData.get("pushDateTime")) &&
      IS_VALID(selectedData.get("sendType")) &&
      selectedData.get("sendType") === "SCHEDULED" &&
      !moment(selectedData.get("pushDateTime")).isBefore(moment())
    ) {
      isPushDateTimeValid = true;
    } else if (
      IS_VALID(selectedData) &&
      IS_VALID(selectedData.get("sendType")) &&
      selectedData.get("sendType") === "IMMEDIATE"
    ) {
      isPushDateTimeValid = true;
    }

    return (
      <div>
        <Table
          bordered
          responsive
          style={{
            tableLayout: "fixed"
          }}
          >
          <tbody>
            {data.map((item, index) => (
              <tr id={index}>
                <td>
                  <b>{item.label}</b>
                </td>
                <td>{item.value}</td>
              </tr>
            ))}
          </tbody>
        </Table>
        <Table
          bordered
          responsive
          style={{
            tableLayout: "fixed"
          }}
          >
          <tbody>
            {data2.map((item, index) => (
              <tr id={index}>
                <td>
                  <b>{item.label}</b>
                </td>
                <td>{item.value}</td>
              </tr>
            ))}
          </tbody>
        </Table>
        <Table
          bordered
          responsive
          style={{
            tableLayout: "fixed"
          }}
          >
          <tbody>
            {data3.map((item, index) => (
              <tr id={index}>
                <td>
                  <b>{item.label}</b>
                </td>
                <td>{item.value}</td>
              </tr>
            ))}
          </tbody>
        </Table>
        {isStarted ? (
          <Row>
            <Col
              md={6}
              mdOffset={3}
              style={{ textAlign: "center" }}
              >
              <h4>
                {isLoadingAction ? (
                  "Sending Push Notification..."
                ) : (
                  <p>Sending in <span style={{ color: "red" }}>{timeLeft}</span> seconds</p>
                )}
              </h4>
            </Col>
          </Row>
        ) : (
          ""
        )}
        {status === "INACTIVE" ? (
          accessible("SEND NOTIFICATION") === "" ? (
            <Row>
              <Col
                md={6}
                mdOffset={3}
                >
                {isPushDateTimeValid ? (
                  <Button
                    className="btn-primary"
                    bsSize="large"
                    style={{ width: "100%" }}
                    onClick={() => {
                      if (!isLoadingAction) {
                        this.startTimer(isStarted);
                      }
                    }}
                    disabled={isLoadingAction}
                    >
                    {isStarted ? "CANCEL" : "SEND"}
                  </Button>
                ) : !isPushDateTimeValid ? (
                  <p>Schedule already passed. Kindly update the schedule by editing the push notification configuration.</p>
                ) : (
                  ""
                )}
              </Col>
            </Row>
          ) : (
            ""
          )
        ) : (
          ""
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/ScheduledNotification/FormContainer/View.js